//import resources
import NewsLetterBg from '../../../assets/images/bg-newletter.jpg'

//import locales
import { useTranslation } from "react-i18next";
import "../../../i18n";

export default function Subscribe() {

    const { t } = useTranslation();

    return (
        <div className='px-3 py-[95px] before:content-[""] before:absolute before:top-0 before:left-0 before:w-full before:h-full before:bg-slate-900/70 relative rounded-xl overflow-hidden' style={{ backgroundImage: `url(${NewsLetterBg})` }}>
            <div className='z-10 relative'>
                <div className='upper text-center text-white text-[18px] lg:text-2xl mb-1'>{t('join')}</div>
                <div className='upper text-center text-white text-[25px] lg:text-4xl mb-5'>{t('news_subscribtion')}</div>
                <div className='text-center text-white text-md'>{t('news_subscribtion_text')}</div>
                <div className='max-w-[600px] mx-auto mt-12 flex items-center'>
                    <input type="text" name="search" className="border border-gray-300 text-slate-900 text-sm rounded-l-3xl block w-full px-3 h-[50px] !outline-none placeholder:text-slate-500" placeholder={t('enter_email')} />
                    <button className='bg-[var(--orange)] h-[50px] rounded-r-3xl px-4 text-white flex items-center justify-center text-sm'>{t('subscribe')}</button>
                </div>
            </div>
        </div>
    );
}